var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgRotate = function SvgRotate(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21 10.64a9.4 9.4 0 0 0-7.26 3.51 1.2 1.2 0 0 1-1.76.12 1.37 1.37 0 0 1-.12-1.86C14.1 9.7 17.36 8 21 8c6.7 0 12.12 5.8 12.25 12.94l.6-.66a1.2 1.2 0 0 1 1.77-.02c.5.5.5 1.34.02 1.86L32.9 25.1c-.23.25-.55.4-.89.4-.34 0-.66-.15-.9-.4l-2.74-2.97a1.37 1.37 0 0 1 .02-1.86 1.2 1.2 0 0 1 1.76.02l.6.64c-.13-5.73-4.46-10.28-9.74-10.28Zm-11 6.27c.34 0 .66.15.9.4l2.74 2.97c.49.52.48 1.36-.02 1.86-.49.51-1.28.5-1.76-.02l-.6-.64c.13 5.73 4.46 10.28 9.74 10.28a9.4 9.4 0 0 0 7.26-3.51 1.2 1.2 0 0 1 1.76-.12c.52.48.57 1.3.12 1.86-2.24 2.7-5.5 4.41-9.14 4.41-6.7 0-12.12-5.8-12.25-12.94l-.6.66a1.2 1.2 0 0 1-1.77.02c-.5-.5-.5-1.34-.02-1.86L9.1 17.3c.23-.25.55-.4.89-.4Z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgRotate);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/rotate.8b840f3d4cef18544785c8efcff329d9.svg";